import React, {Fragment, useEffect, useState } from 'react';
import {TPublicationList, generatePDF} from './CV';
import {Link} from 'react-router-dom'
import {KTSVG} from '../../../../_metronic/helpers'

interface PublicationListProps {
    items: TPublicationList, // don't have to redeclare the object again
};

const CVList: React.FC<PublicationListProps> = (props) => {
    const [loader, setLoader] = useState({state: false, index: null})
    return (
        <Fragment>
            {props.items.map(publication => (
                <tr key={publication.nid}>
                    <td>
                        <div className='d-flex align-items-center'>
                            <div className='d-flex justify-content-start flex-column'>
                                <span className='text-dark fw-bolder text-hover-primary mb-1 fs-7'>
                                    {publication.nothing !== ' ' ? publication.nothing : publication.title }
                                </span>
                                <span className='text-muted fw-bold text-muted d-block fs-7'>
                                {publication.roles_target_id}
                                </span>
                            </div>
                        </div>
                    </td>
                    <td>
                        { /*console.log(publication.field_job_title) */}
                        <span className='text-dark fw-bolder d-block mb-1 fs-7'>{publication.field_job_title}</span>
                    </td>
                    <td>
                        <span className='text-dark fw-bolder d-block mb-1 fs-7'>{publication.field_faculty.replace("&amp;", "&")}</span>
                    </td>
                    <td>
                        <span className='text-dark fw-bolder d-block mb-1 fs-7'>{publication.field_campus}</span>
                    </td>
                    <td>
                        <span className='text-dark fw-bolder d-block mb-1 fs-7'>{publication.changed}</span>
                    </td>
                    <td>
                        <span className='badge badge-light-primary fs-7 fw-bold'>{publication.field_status}</span>
                    </td>
                    <td className='text-end'>
                        <Link to={'/profile/edit/'+publication.nid} className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1 mb-2'>
                            <KTSVG path='/media/icons/duotune/art/art005.svg' className='svg-icon-3' />
                        </Link>
                        {(loader.state && loader.index === publication.nid) ?(
                            <span className="text-muted">Loading</span>
                            ):(
                            <button
                            onClick={()=> generatePDF(publication.nid, publication.nothing, setLoader, publication.nid)}
                            className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1 mb-2'
                            >
                            <KTSVG path='/media/icons/duotune/files/fil009.svg' className='svg-icon-3' />
                            </button>
                            )

                        }
                    </td>
                </tr>
            ))}
        </Fragment>
    );
};

export default CVList;